<template>
  <div v-if="!taskError" class="task taskEval">
    <span v-if="task.label && task.label !== ''" class="taskLabel">{{ task.label }}: </span>
    <transition name="fade" mode="out-in">
      <spinner-loading v-if="taskLoading" class="spinner-loading" :size="18" :line-size='2' line-fg-color='#5dbecd' />
      <span v-else-if="taskResp && taskResp !== ''" class="message label validate ok"> {{ taskResp }} </span>
      <span v-else-if="taskError" class="message label validate error"> {{ getLang('taskError') }} </span>
    </transition>
  </div>
</template>

<script>
import * as api from '../../utils/definitionApi'
import SpinnerLoading from '@/components/shared/SpinnerLoading.vue'
import language from '../../language'

export default {
  name: 'definition-task-eval',
  props: [
    'task',
    'definition',
    'object',
    'taskRefresh',
    'definitionContentId',
    'repeatableGroupCode',
    'languageSelected',
    'newEval',
    'language',
    'authorization',
    'type',
    'callTask'
  ],
  data () {
    return {
      taskError: false,
      taskResp: '',
      taskLoading: true
    }
  },
  components: {
    SpinnerLoading
  },
  methods: {
    callTaskService () {
      this.taskLoading = true
      api.call({domainEndpoint: this.type.domainEndpoint, url: this.task.type.endpoint, token: this.type.token, version: this.type.version, method: 'POST', lang: this.getLang(), authorization: this.authorization, data: { id: this.definitionContentId, code: this.repeatableGroupCode, requestObject: this.object }})
        .then(resp => {
          if (resp.requestResult) {
            this.taskError = false
            this.taskResp = resp.requestResultSuccess
            if (resp.requestObject) {
              for (var i = 0; i < resp.requestObject.length; i++) {
                this.$emit('refreshDefinition', resp.requestObject[i])
              }
            }
          } else {
            this.taskError = true
            this.taskResp = resp.requestResultError.requestErrorMsg
          }
          this.taskLoading = false
        })
        .catch(err => {
          console.log(err)
          this.taskError = true
          this.taskLoading = false
        })
    },
    getLang (key) {
      return language(this.language, key)
    }
  },
  beforeMount () {
    // call if is not 'evalOnChange'
    if (this.task.type.id === 'eval') {
      this.callTaskService()
    } else {
      this.taskLoading = false
    }
  },
  watch: {
    object: {
      handler: function (newVal) {
        if (this.object[0] && !this.object[0].children) {
          this.callTaskService()
        }
      },
      deep: true
    },
    newEval (newEval) {
      this.callTaskService()
    },
    taskRefresh (taskRefresh) {
      this.callTaskService()
    }
  }
}
</script>

<style lang="scss">
.taskEval {
  background-color: transparent;
  min-height: 40px;
  border-radius: 2px;
  text-align: left;
  float: left;

  .taskLabel {
    color: #4599a4;
    vertical-align: middle;
    display: inline-block;
    font-size: 12px;
  }

  .message.label.validate {
    padding-top: 0;
    font-size: 13px;
    position: relative;
    display: inline-block;
    vertical-align: middle;
    line-height: inherit;

    &.error {
      color: #df0000 !important;
      font-weight: bold;
    }

    &.ok {
      font-weight: bold;
    }
  }

  .vue-simple-spinner {
    width: 18px !important;
    height: 18px !important;
  }
}
.groupTasks {
  .taskEval {
    padding-left: 10px;
    background-color: transparent;
    width: 100%;

    .spinner-loading {
      display: inline-block;
    }
  }
}
</style>
